<script>
    export let title, xtrclass, img, imgclass, textSize = 'text-lg';
</script>

<div class="flex flex-row items-center justify-start w-full p-2 rounded-md shadow-lg {xtrclass}">
    <img src={img || 'https://via.placeholder.com/256'} class="w-10 h-10 p-1 mr-2 bg-gray-200 rounded-md {imgclass}" alt={title}>
    <h1 class="{textSize}">{@html title}</h1>
</div>